var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// Generated by `npm run icon`, don't modify this file
import React from 'react';
import Base from './_base';
const AngleDown = props => {
    const { className = null } = props, other = __rest(props, ["className"]);
    return (<Base viewBox="0 0 16 16" className={`cuk2-icon-angle_down ${className}`} {...other}>
      <g>
        <path d="M2.816 6.017l5.177 5.177 5.177-5.177a.5.5 0 000-.707l-.354-.354a.5.5 0 00-.707 0L7.993 9.072 3.877 4.956a.5.5 0 00-.707 0l-.354.354a.5.5 0 000 .707z" fillRule="evenodd"/>
      </g>
    </Base>);
};
export default AngleDown;
